'use client';

import { ResponsivePicture } from '@libs/shared-ui';
import { HtmlStringToReact, clsx } from '@libs/common-next';
import { Button, TextPassage } from '@petsmart-ui/sparky';
import type { ProductDescriptionTabHtmlProps } from '@app/pdp/components/ProductDescription/types';
import { useCallback, useEffect, useState } from 'react';

const MAXIMUMHEIGHT = 350;
const IMG_SIZE_SIZECHART = {
    width: 500,
    height: 500,
};

export default function ProductDescriptionTabHtml({
    htmlString,
    sizeChartImgUrl,
    title,
}: ProductDescriptionTabHtmlProps) {
    const [shouldDisplayButton, setShouldDisplayButton] = useState(false);
    const [isExpanded, setIsExpanded] = useState(false);
    const [dimensions, setDimensions] = useState<DOMRect>();

    const callBackRef = useCallback((domNode: HTMLDivElement) => {
        if (domNode) {
            setDimensions(domNode.getBoundingClientRect());
        }
    }, []);

    const wrapperClasses = clsx(
        'description-tab-wrapper',
        isExpanded && 'expanded'
    );

    useEffect(() => {
        const textPassageHeight = dimensions?.height;

        if (textPassageHeight && textPassageHeight > MAXIMUMHEIGHT) {
            setShouldDisplayButton(true);
        }
    }, [dimensions?.height, htmlString]);

    const onToggleExpand = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <div className={wrapperClasses}>
                <div ref={callBackRef} className="description-tab-content">
                    <TextPassage capLinelength={false}>
                        <HtmlStringToReact htmlString={htmlString} />
                    </TextPassage>
                    {sizeChartImgUrl && title === 'Size' && (
                        <ResponsivePicture
                            src={sizeChartImgUrl}
                            size={IMG_SIZE_SIZECHART}
                            alt="Size chart"
                            className="description-tab-image"
                        />
                    )}
                </div>
            </div>
            {shouldDisplayButton && (
                <Button
                    className="see-more-button"
                    variant="link"
                    text={isExpanded ? 'See less' : 'See more'}
                    onClick={onToggleExpand}
                />
            )}
        </>
    );
}
